import { useState } from 'react';
import { Country, formatPhoneNumberIntl, isSupportedCountry } from 'react-phone-number-input/max';
import useSingleCompanySetting from './adminPage/useSingleCompanySetting';

const usePublicPhoneCountryAndPlaceholder = () => {
    const winDefaultCountry =
        navigator.languages?.[0]?.split('-')[1] ||
        navigator.language?.split('-')[1] ||
        languageList[navigator.language] ||
        'US';

    const phoneCountry = isSupportedCountry(winDefaultCountry as Country)
        ? (winDefaultCountry as Country)
        : ('US' as Country);

    const [phonePlaceHolder, setPlaceholder] = useState(
        formatPhoneNumberIntl(phonePlaceholders[phoneCountry]?.exampleNumber || '+90 500 123 45 67')
    );
    const changePlaceHolderByCountryCode = (countryCode: Country) => {
        setPlaceholder(formatPhoneNumberIntl(phonePlaceholders[countryCode]?.exampleNumber || '+90 500 123 45 67'));
    };

    return { phoneCountry, phonePlaceHolder, changePlaceHolderByCountryCode };
};
const useCompanyPhoneCountryAndPlaceholder = () => {
    const { data: companyLanguage } = useSingleCompanySetting('LANGUAGE');
    const [phonePlaceHolder, setPlaceholder] = useState(
        formatPhoneNumberIntl(
            phonePlaceholders[companyLanguage as unknown as Country]?.exampleNumber || '+90 500 123 45 67'
        )
    );
    const phoneCountry: Country = companyLanguage?.value === 'TR' ? 'TR' : 'US';
    const changePlaceHolderByCountryCode = (countryCode: Country) => {
        setPlaceholder(formatPhoneNumberIntl(phonePlaceholders[countryCode]?.exampleNumber || '+90 500 123 45 67'));
    };

    return { phoneCountry, phonePlaceHolder, changePlaceHolderByCountryCode };
};

export { useCompanyPhoneCountryAndPlaceholder, usePublicPhoneCountryAndPlaceholder };
export const phonePlaceholders = {
    AC: { country: 'AC', exampleNumber: '+24740123' },
    AD: { country: 'AD', exampleNumber: '+376312345' },
    AE: { country: 'AE', exampleNumber: '+971501234567' },
    AF: { country: 'AF', exampleNumber: '+93701234567' },
    AG: { country: 'AG', exampleNumber: '+12684641234' },
    AI: { country: 'AI', exampleNumber: '+12642351234' },
    AL: { country: 'AL', exampleNumber: '+355672123456' },
    AM: { country: 'AM', exampleNumber: '+37477123456' },
    AO: { country: 'AO', exampleNumber: '+244923123456' },
    AR: { country: 'AR', exampleNumber: '+5491123456789' },
    AS: { country: 'AS', exampleNumber: '+16847331234' },
    AT: { country: 'AT', exampleNumber: '+43664123456' },
    AU: { country: 'AU', exampleNumber: '+61412345678' },
    AW: { country: 'AW', exampleNumber: '+2975601234' },
    AX: { country: 'AX', exampleNumber: '+358412345678' },
    AZ: { country: 'AZ', exampleNumber: '+994401234567' },
    BA: { country: 'BA', exampleNumber: '+38761123456' },
    BB: { country: 'BB', exampleNumber: '+12462501234' },
    BD: { country: 'BD', exampleNumber: '+8801812345678' },
    BE: { country: 'BE', exampleNumber: '+32470123456' },
    BF: { country: 'BF', exampleNumber: '+22670123456' },
    BG: { country: 'BG', exampleNumber: '+35943012345' },
    BH: { country: 'BH', exampleNumber: '+97336001234' },
    BI: { country: 'BI', exampleNumber: '+25779561234' },
    BJ: { country: 'BJ', exampleNumber: '+22990011234' },
    BL: { country: 'BL', exampleNumber: '+590690001234' },
    BM: { country: 'BM', exampleNumber: '+14413701234' },
    BN: { country: 'BN', exampleNumber: '+6737123456' },
    BO: { country: 'BO', exampleNumber: '+59171234567' },
    BQ: { country: 'BQ', exampleNumber: '+5993181234' },
    BR: { country: 'BR', exampleNumber: '+5511961234567' },
    BS: { country: 'BS', exampleNumber: '+12423591234' },
    BT: { country: 'BT', exampleNumber: '+97517123456' },
    BW: { country: 'BW', exampleNumber: '+26771123456' },
    BY: { country: 'BY', exampleNumber: '+375294911911' },
    BZ: { country: 'BZ', exampleNumber: '+5016221234' },
    CA: { country: 'CA', exampleNumber: '+15062345678' },
    CC: { country: 'CC', exampleNumber: '+61412345678' },
    CD: { country: 'CD', exampleNumber: '+243991234567' },
    CF: { country: 'CF', exampleNumber: '+23670012345' },
    CG: { country: 'CG', exampleNumber: '+242061234567' },
    CH: { country: 'CH', exampleNumber: '+41781234567' },
    CI: { country: 'CI', exampleNumber: '+2250123456789' },
    CK: { country: 'CK', exampleNumber: '+68271234' },
    CL: { country: 'CL', exampleNumber: '+56221234567' },
    CM: { country: 'CM', exampleNumber: '+237671234567' },
    CN: { country: 'CN', exampleNumber: '+8613123456789' },
    CO: { country: 'CO', exampleNumber: '+573211234567' },
    CR: { country: 'CR', exampleNumber: '+50683123456' },
    CU: { country: 'CU', exampleNumber: '+5351234567' },
    CV: { country: 'CV', exampleNumber: '+2389911234' },
    CW: { country: 'CW', exampleNumber: '+59995181234' },
    CX: { country: 'CX', exampleNumber: '+61412345678' },
    CY: { country: 'CY', exampleNumber: '+35796123456' },
    CZ: { country: 'CZ', exampleNumber: '+420601123456' },
    DE: { country: 'DE', exampleNumber: '+4915123456789' },
    DJ: { country: 'DJ', exampleNumber: '+25377831001' },
    DK: { country: 'DK', exampleNumber: '+4532123456' },
    DM: { country: 'DM', exampleNumber: '+17672251234' },
    DO: { country: 'DO', exampleNumber: '+18092345678' },
    DZ: { country: 'DZ', exampleNumber: '+213551234567' },
    EC: { country: 'EC', exampleNumber: '+593991234567' },
    EE: { country: 'EE', exampleNumber: '+37251234567' },
    EG: { country: 'EG', exampleNumber: '+201001234567' },
    EH: { country: 'EH', exampleNumber: '+212650123456' },
    ER: { country: 'ER', exampleNumber: '+2917123456' },
    ES: { country: 'ES', exampleNumber: '+34612345678' },
    ET: { country: 'ET', exampleNumber: '+251911234567' },
    FI: { country: 'FI', exampleNumber: '+358412345678' },
    FJ: { country: 'FJ', exampleNumber: '+6797012345' },
    FK: { country: 'FK', exampleNumber: '+50051234' },
    FM: { country: 'FM', exampleNumber: '+6913501234' },
    FO: { country: 'FO', exampleNumber: '+298211234' },
    FR: { country: 'FR', exampleNumber: '+33612345678' },
    GA: { country: 'GA', exampleNumber: '+24106031234' },
    GB: { country: 'GB', exampleNumber: '+447400123456' },
    GD: { country: 'GD', exampleNumber: '+14734031234' },
    GE: { country: 'GE', exampleNumber: '+995555123456' },
    GF: { country: 'GF', exampleNumber: '+594694201234' },
    GG: { country: 'GG', exampleNumber: '+447781123456' },
    GH: { country: 'GH', exampleNumber: '+233231234567' },
    GI: { country: 'GI', exampleNumber: '+35057123456' },
    GL: { country: 'GL', exampleNumber: '+299221234' },
    GM: { country: 'GM', exampleNumber: '+2203012345' },
    GN: { country: 'GN', exampleNumber: '+224601123456' },
    GP: { country: 'GP', exampleNumber: '+590690001234' },
    GQ: { country: 'GQ', exampleNumber: '+240222123456' },
    GR: { country: 'GR', exampleNumber: '+306912345678' },
    GT: { country: 'GT', exampleNumber: '+50251234567' },
    GU: { country: 'GU', exampleNumber: '+16713001234' },
    GW: { country: 'GW', exampleNumber: '+245955012345' },
    GY: { country: 'GY', exampleNumber: '+5926091234' },
    HK: { country: 'HK', exampleNumber: '+85251234567' },
    HN: { country: 'HN', exampleNumber: '+50491234567' },
    HR: { country: 'HR', exampleNumber: '+385921234567' },
    HT: { country: 'HT', exampleNumber: '+50934101234' },
    HU: { country: 'HU', exampleNumber: '+36201234567' },
    ID: { country: 'ID', exampleNumber: '+62812345678' },
    IE: { country: 'IE', exampleNumber: '+353850123456' },
    IL: { country: 'IL', exampleNumber: '+972502345678' },
    IM: { country: 'IM', exampleNumber: '+447924123456' },
    IN: { country: 'IN', exampleNumber: '+918123456789' },
    IO: { country: 'IO', exampleNumber: '+2463801234' },
    IQ: { country: 'IQ', exampleNumber: '+9647912345678' },
    IR: { country: 'IR', exampleNumber: '+989123456789' },
    IS: { country: 'IS', exampleNumber: '+3546111234' },
    IT: { country: 'IT', exampleNumber: '+393123456789' },
    JE: { country: 'JE', exampleNumber: '+447797712345' },
    JM: { country: 'JM', exampleNumber: '+18762101234' },
    JO: { country: 'JO', exampleNumber: '+962790123456' },
    JP: { country: 'JP', exampleNumber: '+819012345678' },
    KE: { country: 'KE', exampleNumber: '+254712123456' },
    KG: { country: 'KG', exampleNumber: '+996700123456' },
    KH: { country: 'KH', exampleNumber: '+85591234567' },
    KI: { country: 'KI', exampleNumber: '+68672001234' },
    KM: { country: 'KM', exampleNumber: '+2693212345' },
    KN: { country: 'KN', exampleNumber: '+18697652917' },
    KP: { country: 'KP', exampleNumber: '+8501921234567' },
    KR: { country: 'KR', exampleNumber: '+821020000000' },
    KW: { country: 'KW', exampleNumber: '+96550012345' },
    KY: { country: 'KY', exampleNumber: '+13453231234' },
    KZ: { country: 'KZ', exampleNumber: '+77710009998' },
    LA: { country: 'LA', exampleNumber: '+8562023123456' },
    LB: { country: 'LB', exampleNumber: '+96171123456' },
    LC: { country: 'LC', exampleNumber: '+17582845678' },
    LI: { country: 'LI', exampleNumber: '+423660234567' },
    LK: { country: 'LK', exampleNumber: '+94712345678' },
    LR: { country: 'LR', exampleNumber: '+231770123456' },
    LS: { country: 'LS', exampleNumber: '+26650123456' },
    LT: { country: 'LT', exampleNumber: '+37061234567' },
    LU: { country: 'LU', exampleNumber: '+352628123456' },
    LV: { country: 'LV', exampleNumber: '+37121234567' },
    LY: { country: 'LY', exampleNumber: '+218912345678' },
    MA: { country: 'MA', exampleNumber: '+212650123456' },
    MC: { country: 'MC', exampleNumber: '+377612345678' },
    MD: { country: 'MD', exampleNumber: '+37362112345' },
    ME: { country: 'ME', exampleNumber: '+38267622901' },
    MF: { country: 'MF', exampleNumber: '+590690001234' },
    MG: { country: 'MG', exampleNumber: '+261321234567' },
    MH: { country: 'MH', exampleNumber: '+6922351234' },
    MK: { country: 'MK', exampleNumber: '+38972345678' },
    ML: { country: 'ML', exampleNumber: '+22365012345' },
    MM: { country: 'MM', exampleNumber: '+9592123456' },
    MN: { country: 'MN', exampleNumber: '+97688123456' },
    MO: { country: 'MO', exampleNumber: '+85366123456' },
    MP: { country: 'MP', exampleNumber: '+16702345678' },
    MQ: { country: 'MQ', exampleNumber: '+596696201234' },
    MR: { country: 'MR', exampleNumber: '+22222123456' },
    MS: { country: 'MS', exampleNumber: '+16644923456' },
    MT: { country: 'MT', exampleNumber: '+35696961234' },
    MU: { country: 'MU', exampleNumber: '+23052512345' },
    MV: { country: 'MV', exampleNumber: '+9607712345' },
    MW: { country: 'MW', exampleNumber: '+265991234567' },
    MX: { country: 'MX', exampleNumber: '+5212221234567' },
    MY: { country: 'MY', exampleNumber: '+60123456789' },
    MZ: { country: 'MZ', exampleNumber: '+258821234567' },
    NA: { country: 'NA', exampleNumber: '+264811234567' },
    NC: { country: 'NC', exampleNumber: '+687751234' },
    NE: { country: 'NE', exampleNumber: '+22793123456' },
    NF: { country: 'NF', exampleNumber: '+672381234' },
    NG: { country: 'NG', exampleNumber: '+2348021234567' },
    NI: { country: 'NI', exampleNumber: '+50581234567' },
    NL: { country: 'NL', exampleNumber: '+31612345678' },
    NO: { country: 'NO', exampleNumber: '+4740612345' },
    NP: { country: 'NP', exampleNumber: '+9779841234567' },
    NR: { country: 'NR', exampleNumber: '+6745551234' },
    NU: { country: 'NU', exampleNumber: '+6838884012' },
    NZ: { country: 'NZ', exampleNumber: '+64211234567' },
    OM: { country: 'OM', exampleNumber: '+96892123456' },
    PA: { country: 'PA', exampleNumber: '+50761234567' },
    PE: { country: 'PE', exampleNumber: '+51912345678' },
    PF: { country: 'PF', exampleNumber: '+68987123456' },
    PG: { country: 'PG', exampleNumber: '+67570123456' },
    PH: { country: 'PH', exampleNumber: '+639051234567' },
    PK: { country: 'PK', exampleNumber: '+923012345678' },
    PL: { country: 'PL', exampleNumber: '+48512345678' },
    PM: { country: 'PM', exampleNumber: '+508551234' },
    PR: { country: 'PR', exampleNumber: '+17872345678' },
    PS: { country: 'PS', exampleNumber: '+970599123456' },
    PT: { country: 'PT', exampleNumber: '+351912345678' },
    PW: { country: 'PW', exampleNumber: '+6806201234' },
    PY: { country: 'PY', exampleNumber: '+595961456789' },
    QA: { country: 'QA', exampleNumber: '+97433123456' },
    RE: { country: 'RE', exampleNumber: '+262692123456' },
    RO: { country: 'RO', exampleNumber: '+40712034567' },
    RS: { country: 'RS', exampleNumber: '+381601234567' },
    RU: { country: 'RU', exampleNumber: '+79123456789' },
    RW: { country: 'RW', exampleNumber: '+250720123456' },
    SA: { country: 'SA', exampleNumber: '+966512345678' },
    SB: { country: 'SB', exampleNumber: '+6777421234' },
    SC: { country: 'SC', exampleNumber: '+2482510123' },
    SD: { country: 'SD', exampleNumber: '+249911231234' },
    SE: { country: 'SE', exampleNumber: '+46701234567' },
    SG: { country: 'SG', exampleNumber: '+6581234567' },
    SH: { country: 'SH', exampleNumber: '+29051234' },
    SI: { country: 'SI', exampleNumber: '+38631234567' },
    SJ: { country: 'SJ', exampleNumber: '+4741234567' },
    SK: { country: 'SK', exampleNumber: '+421912123456' },
    SL: { country: 'SL', exampleNumber: '+23225123456' },
    SM: { country: 'SM', exampleNumber: '+37866661212' },
    SN: { country: 'SN', exampleNumber: '+221701234567' },
    SO: { country: 'SO', exampleNumber: '+25271123456' },
    SR: { country: 'SR', exampleNumber: '+5977412345' },
    SS: { country: 'SS', exampleNumber: '+211977123456' },
    ST: { country: 'ST', exampleNumber: '+2399812345' },
    SV: { country: 'SV', exampleNumber: '+50370123456' },
    SX: { country: 'SX', exampleNumber: '+17215205678' },
    SY: { country: 'SY', exampleNumber: '+963944567890' },
    SZ: { country: 'SZ', exampleNumber: '+26876123456' },
    TA: { country: 'TA', exampleNumber: '+2908999' },
    TC: { country: 'TC', exampleNumber: '+16492311234' },
    TD: { country: 'TD', exampleNumber: '+23563012345' },
    TG: { country: 'TG', exampleNumber: '+22890112345' },
    TH: { country: 'TH', exampleNumber: '+66812345678' },
    TJ: { country: 'TJ', exampleNumber: '+992917123456' },
    TK: { country: 'TK', exampleNumber: '+6907290' },
    TL: { country: 'TL', exampleNumber: '+67077212345' },
    TM: { country: 'TM', exampleNumber: '+99366123456' },
    TN: { country: 'TN', exampleNumber: '+21620123456' },
    TO: { country: 'TO', exampleNumber: '+6767715123' },
    TR: { country: 'TR', exampleNumber: '+905001234567' },
    TT: { country: 'TT', exampleNumber: '+18682911234' },
    TV: { country: 'TV', exampleNumber: '+688901234' },
    TW: { country: 'TW', exampleNumber: '+886912345678' },
    TZ: { country: 'TZ', exampleNumber: '+255621234567' },
    UA: { country: 'UA', exampleNumber: '+380501234567' },
    UG: { country: 'UG', exampleNumber: '+256712345678' },
    US: { country: 'US', exampleNumber: '+12015550123' },
    UY: { country: 'UY', exampleNumber: '+59894231234' },
    UZ: { country: 'UZ', exampleNumber: '+998912345678' },
    VA: { country: 'VA', exampleNumber: '+393123456789' },
    VC: { country: 'VC', exampleNumber: '+17844301234' },
    VE: { country: 'VE', exampleNumber: '+584121234567' },
    VG: { country: 'VG', exampleNumber: '+12843001234' },
    VI: { country: 'VI', exampleNumber: '+13406421234' },
    VN: { country: 'VN', exampleNumber: '+84912345678' },
    VU: { country: 'VU', exampleNumber: '+6785912345' },
    WF: { country: 'WF', exampleNumber: '+681821234' },
    WS: { country: 'WS', exampleNumber: '+6857212345' },
    XK: { country: 'XK', exampleNumber: '+38343201234' },
    YE: { country: 'YE', exampleNumber: '+967712345678' },
    YT: { country: 'YT', exampleNumber: '+262639012345' },
    ZA: { country: 'ZA', exampleNumber: '+27711234567' },
    ZM: { country: 'ZM', exampleNumber: '+260955123456' },
    ZW: { country: 'ZW', exampleNumber: '+263712345678' }
};
export const languageList = {
    ab: 'GE',
    af: 'ZA',
    am: 'ET',
    ar: 'EG',
    as: 'IN',
    ay: 'BO',
    az: 'AZ',
    be: 'BY',
    bg: 'BG',
    bn: 'BD',
    bo: 'CN',
    bs: 'BA',
    ca: 'ES',
    cs: 'CZ',
    cy: 'GB',
    da: 'DK',
    de: 'DE',
    dv: 'MV',
    el: 'GR',
    en: 'US',
    eo: 'None',
    es: 'MX',
    et: 'EE',
    eu: 'ES',
    fa: 'IR',
    fi: 'FI',
    fo: 'FO',
    fr: 'FR',
    ga: 'IE',
    gl: 'ES',
    gu: 'IN',
    he: 'IL',
    hi: 'IN',
    hr: 'HR',
    hu: 'HU',
    hy: 'AM',
    id: 'ID',
    is: 'IS',
    it: 'IT',
    ja: 'JP',
    jv: 'ID',
    ka: 'GE',
    kk: 'KZ',
    km: 'KH',
    kn: 'IN',
    ko: 'KR',
    ku: 'TR',
    ky: 'KG',
    la: 'VA',
    lo: 'LA',
    lt: 'LT',
    lv: 'LV',
    mg: 'MG',
    mk: 'MK',
    ml: 'IN',
    mn: 'MN',
    mr: 'IN',
    ms: 'MY',
    mt: 'MT',
    my: 'MM',
    nb: 'NO',
    ne: 'NP',
    nl: 'NL',
    nn: 'NO',
    no: 'NO',
    or: 'IN',
    pa: 'PK',
    pl: 'PL',
    ps: 'AF',
    pt: 'BR',
    ro: 'RO',
    ru: 'RU',
    sd: 'PK',
    si: 'LK',
    sk: 'SK',
    sl: 'SI',
    so: 'SO',
    sq: 'AL',
    sr: 'RS',
    sv: 'SE',
    sw: 'TZ',
    ta: 'IN',
    te: 'IN',
    th: 'TH',
    tk: 'TM',
    tl: 'PH',
    tr: 'TR',
    uk: 'UA',
    ur: 'PK',
    vi: 'VN',
    xh: 'ZA',
    yi: 'IL',
    zu: 'ZA'
};
